import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IncludesChecklist() {
  const items = [{
    title: 'Tomo 1 — Fundamentos de la Producción Agropecuaria'
  }, {
    title: 'Tomo 2 — Agricultura, Suelos, Fertilización y Riego'
  }, {
    title: 'Tomo 3 — Maquinaria, Ganadería y Producción Sustentable'
  }, {
    title: 'Tomo 4 — Agroindustria, Economía, Gestión y Tecnología'
  }, {
    title: 'Libro — Gestión y Economía Agropecuaria'
  }, {
    title: 'Libro — Suelos y Fertilización Avanzada'
  }, {
    title: 'Libro — Sistemas de Riego e Hidrología'
  }, {
    title: 'Libro — Tecnologías en el Agro'
  }, {
    title: 'Libro 1 Ganadería — Introducción a la Producción Animal'
  }, {
    title: 'Libro 2 Ganadería — Anatomía y Fisiología Animal'
  }, {
    title: 'Libro 3 Ganadería — Nutrición y Alimentación Animal'
  }, {
    title: 'Libro 4 Ganadería — Reproducción Animal'
  }, {
    title: 'Libro 5 Ganadería — Sanidad Animal'
  }, {
    title: 'Módulo 6 — Producción Bovina Completa'
  }, {
    title: 'Libro 7 — Producción Porcina'
  }, {
    title: 'Libro 8 — Producción Aviar'
  }, {
    title: 'Libro 9 — Instalaciones Ganaderas'
  }, {
    title: 'Tomo 10 — Bienestar Animal'
  }, {
    title: 'Tomo 11 — Producción Sustentable'
  }, {
    title: 'Bono 1 — Actividades de Agricultura y Suelos'
  }, {
    title: 'Bono 2 — Evaluaciones de Ganadería'
  }, {
    title: 'Bono 3 — Prácticas de Maquinaria y Sustentabilidad'
  }, {
    title: 'Bono 4 — Ejercicios de Agroindustria y Tecnología'
  }, {
    title: 'Garantía de 7 días sin preguntas'
  }, {
    title: 'Acceso inmediato'
  }, {
    title: 'Formato PDF listo para usar'
  }];
  return <section className="py-12 bg-[#f5f0e6] border-y border-[#e2e8f0]" data-id="element-156">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-157">
        <h3 className="text-2xl font-bold text-center mb-10 text-[#1a3622]" data-id="element-158">
          📦 TODO LO QUE INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-159">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.02
        }} className="flex items-start gap-3 p-3 rounded-lg hover:bg-white transition-colors border border-transparent hover:border-[#e2e8f0]" data-id="element-160">
              <CheckCircle2 className="w-5 h-5 text-[#1a3622] shrink-0 mt-0.5" data-id="element-161" />
              <div data-id="element-162">
                <span className="text-[#4a3b32] font-bold text-[14px] block" data-id="element-163">
                  {item.title}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}